export default "<div class=\"side-bar\"></div>\n"